const configuration = {
    "entitlementSource": {
        "displayName": "Entitlement Source",
        "infoMessage": "This will use for the building a attribute based policy",
        "key": "entitlementSource",
        "value": "8a48825a99a88ec80199a8e5349600e4"
    },
    "applicationService": {
        "type": "OAuth",
        "values": {
            "clientId": "1229ad5b-c1de-4bc6-88db-f0275447c2b4",
            "clientSecret": "*****",
            "authUrl": "https://login.microsoftonline.com/64ddf09f-4f98-4b98-a806-f947d4d7a672/oauth2/v2.0/token",
            "scope": "1229ad5b-c1de-4bc6-88db-f0275447c2b4/.default",
            "apiKey": "*****"
        }
    }
}

export default configuration;